import { ExemptionMotive } from "models/ExemptionMotive";
import { ObjectWithAnyValues } from "utils/types";
import { BaseServices } from "./baseServices";

export class ExemptionMotiveService extends BaseServices<ObjectWithAnyValues, ExemptionMotive> {
	static instance = new ExemptionMotiveService();
	static readonly baseEndpoint = "/exemption-motives";

	constructor() {
		super(ExemptionMotive);
	}

	async listExemptionMotives(concessionaireId: string) {
		return this.list(`${ExemptionMotiveService.baseEndpoint}/${concessionaireId}`);
	}

	static getInstance() {
		return ExemptionMotiveService.instance;
	}
}
